import {DropdownArrowDownIcon, DropdownArrowUpIcon} from "@netapp/bxp-style/react-icons/Navigation";

const ServiceNavGroupChevron = ({isOpen}: {isOpen: boolean}) =>
    isOpen ? <DropdownArrowUpIcon /> : <DropdownArrowDownIcon />;

export default ServiceNavGroupChevron;
export {ServiceNavGroupChevron};
